import React, { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface SelectionBarProps {
    /** "12 selected" — already translated. */
    label: ReactNode;
    /** The actions on the selection, at the end: outlined buttons. */
    children: ReactNode;
    /** Hidden (and out of the tab order) while nothing is selected. */
    open: boolean;
    className?: string;
    testId?: string;
}

/**
 * What to do with the things ticked in a list, kept in reach at the bottom of
 * the window while the list scrolls under it.
 *
 * One bar for every multi-select list — confirm a page of matches, add a
 * selection of network products to the catalogue — so choosing several things
 * and acting on them feels the same everywhere. A white card on a hairline,
 * like the rest of the page; no colour, the buttons say what happens.
 */
export const SelectionBar: React.FC<SelectionBarProps> = ({ label, children, open, className, testId }) => {
    if (!open) return null;
    return (
        <div className="pointer-events-none sticky bottom-4 z-20 mt-4 flex justify-center px-2" data-testid={testId}>
            <div
                role="region"
                aria-live="polite"
                className={cn(
                    'pointer-events-auto flex w-full max-w-2xl flex-wrap items-center justify-between gap-3 rounded-xl border bg-card px-4 py-2.5 shadow-sm',
                    className,
                )}
            >
                <span className="text-sm tabular-nums">{label}</span>
                <div className="flex flex-wrap items-center gap-2">{children}</div>
            </div>
        </div>
    );
};
